import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/empty';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';


@Injectable()
export class HttpMethodOverrideInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.setXHttpMethodOverrideHeader(req));
  }
  // Request Interceptor to append X-HTTP-Method-Override Header
  private setXHttpMethodOverrideHeader(req: HttpRequest<any>): HttpRequest<any> {

    if (req){
      if (req.method === 'PUT') {
        return req.clone({ method: 'POST', setHeaders: { 'X-HTTP-Method-Override': 'PUT' } });
      }
      if (req.method === 'PATCH') {
        return req.clone({ method: 'POST', setHeaders: { 'X-HTTP-Method-Override': 'PATCH' } });
      }
      if (req.method === 'DELETE') {
        return req.clone({ method: 'POST', setHeaders: { 'X-HTTP-Method-Override': 'DELETE' } });
      }

      return req.clone();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/http/http.method.override.ts